import { ProductCategory, SelectedProductCategory, SelectedProductType } from 'graphql/types'

const appendArticle = (selectedIds: Set<string>, productTypes: SelectedProductType[], id: string) => {
    if (selectedIds.has(id)) {
        return
    }
    selectedIds.add(id)
    productTypes.push({
        id,
        optionCategories: [],
    })
}

// Discount article numbers are not selected product types. They are attached to the
// order payload so getBookingFromOrder forwards them as optional articles to the CRM.
export const appendDiscountArticles = (
    selectedProductCategories: SelectedProductCategory[],
    availableProductCategories: ProductCategory[],
): void => {
    selectedProductCategories.forEach((selectedProductCategory) => {
        const selectedProduct = selectedProductCategory.selectedProduct
        if (!selectedProduct) {
            return
        }

        const product = availableProductCategories
            .find((category) => category.id === selectedProductCategory.id)
            ?.products.find((candidate) => candidate.id === selectedProduct.id)
        if (!product) {
            return
        }

        const selectedIds = new Set(selectedProduct.productTypes.map((productType) => productType.id))
        const originallySelected = [...selectedProduct.productTypes]

        product.discounts.forEach((discount) => {
            appendArticle(selectedIds, selectedProduct.productTypes, discount.id)
        })

        originallySelected.forEach((productType) => {
            const matchingProductType = product.productTypes.find((candidate) => candidate.id === productType.id)
            if (!matchingProductType?.optional) {
                return
            }
            matchingProductType.discounts.forEach((discount) => {
                appendArticle(selectedIds, selectedProduct.productTypes, discount.id)
            })
        })
    })
}
